 <div class="print-layout" [class.modo-modal]="modoModal">
    <aside class="print-controls-shell no-print">
        <header class="ds-page-header print-hero">
            <div class="ds-page-header-icon" aria-hidden="true">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M6 9V2h12v7"></path>
                    <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
                    <rect x="6" y="14" width="12" height="8"></rect>
                </svg>
            </div>
            <div class="ds-page-header-copy">
                <h1 class="ds-page-title">{{ titulo }}</h1>
                <p class="ds-page-subtitle">Página de impressão</p>
            </div>

            <div
                class="ds-page-actions print-hero-controls"
                aria-label="Parâmetros de impressão"
                *ngIf="documento"
            >
                <fieldset *ngIf="!lista && !pedido">
                    <legend>Conteúdo</legend>
                    <label title="Descrição"
                        ><input
                            type="checkbox"
                            aria-label="Descrição"
                            [(ngModel)]="options.descricao"
                            (change)="atualizar()"
                        />Descr.</label
                    >
                    <label title="Fabricante"
                        ><input
                            type="checkbox"
                            aria-label="Fabricante"
                            [(ngModel)]="options.fabricante"
                            (change)="atualizar()"
                        />Fabri.</label
                    >
                    <label title="Condição"
                        ><input
                            type="checkbox"
                            aria-label="Condição"
                            [(ngModel)]="options.condicao"
                            (change)="atualizar()"
                        />CD</label
                    >
                    <label
                        ><input
                            type="checkbox"
                            [(ngModel)]="options.pn"
                            (change)="atualizar()"
                        />PNs</label
                    >
                    <label title="Dados de faturamento"
                        ><input
                            type="checkbox"
                            aria-label="Dados de faturamento"
                            [(ngModel)]="options.faturamento"
                            (change)="atualizar()"
                        />Fat.</label
                    >
                    <label title="Dados de entrega"
                        ><input
                            type="checkbox"
                            aria-label="Dados de entrega"
                            [(ngModel)]="options.entrega"
                            (change)="atualizar()"
                        />Ent.</label
                    >
                </fieldset>

                <fieldset *ngIf="!lista && !pedido">
                    <legend>Valores</legend>
                    <label
                        ><input
                            type="checkbox"
                            aria-label="Imprimir valores"
                            [(ngModel)]="options.valores"
                            (change)="atualizar()"
                        />Valores</label
                    >
                    <label *ngIf="!dolar"
                        ><input
                            type="checkbox"
                            aria-label="Coluna dólar (em reais)"
                            [(ngModel)]="options.dolar"
                            (change)="atualizar()"
                        />Dólar</label
                    >
                    <label>{{ moeda }}</label>
                </fieldset>

                <fieldset *ngIf="pedido">
                    <legend>Conteúdo</legend>
                    <label title="Coluna fabricante"
                        ><input
                            type="checkbox"
                            aria-label="Coluna fabricante"
                            [(ngModel)]="options.fabricante"
                            (change)="atualizar()"
                        />Fabri.</label
                    >
                    <label title="Coluna código da peça"
                        ><input
                            type="checkbox"
                            aria-label="Coluna código da peça"
                            [(ngModel)]="options.codigo"
                            (change)="atualizar()"
                        />Código</label
                    >
                    <label title="Coluna status"
                        ><input
                            type="checkbox"
                            aria-label="Coluna status"
                            [(ngModel)]="options.status"
                            (change)="atualizar()"
                        />Status</label
                    >
                    <label
                        ><input
                            type="checkbox"
                            aria-label="Imprimir cancelados"
                            [(ngModel)]="options.cancelados"
                            (change)="atualizar()"
                        />Cancel.</label
                    >
                    <label title="Somente abertos e parciais"
                        ><input
                            type="checkbox"
                            aria-label="Somente abertos e parciais"
                            [(ngModel)]="options.abertos"
                            (change)="atualizar()"
                        />Abertos/parciais</label
                    >
                    <label title="Separar por fabricante"
                        ><input
                            type="checkbox"
                            aria-label="Separar por fabricante"
                            [(ngModel)]="options.separarFabricante"
                            (change)="atualizar()"
                        />Por fabri.</label
                    >
                </fieldset>

                <fieldset>
                    <legend>COR</legend>
                    <label
                        ><input
                            type="checkbox"
                            aria-label="Preto e branco"
                            [(ngModel)]="pb"
                        />P/B</label
                    >
                </fieldset>

                <div class="print-hero-actions">
                    <button
                        type="button"
                        class="secondary"
                        (click)="imprimir()"
                        [disabled]="!folhas.length || carregando || exportando"
                    >
                        Imprimir
                    </button>
                    <button
                        type="button"
                        (click)="gerarPdf()"
                        [disabled]="!folhas.length || carregando || exportando"
                    >
                        {{ exportando ? 'Preparando…' : 'Gerar PDF' }}
                    </button>
                </div>

                <details class="compra-opcoes-adicionais">
                    <summary>Mais opções</summary>
                    <div class="compra-opcoes-grid">
                        <fieldset *ngIf="!lista && !pedido">
                            <legend>Complementos</legend>
                            <label
                                ><input
                                    type="checkbox"
                                    [(ngModel)]="options.barras"
                                    (change)="atualizar()"
                                />Código de barras</label
                            >
                            <label
                                ><input
                                    type="checkbox"
                                    [(ngModel)]="options.seriais"
                                    (change)="atualizar()"
                                />Seriais</label
                            >
                            <label
                                ><input
                                    type="checkbox"
                                    [(ngModel)]="options.estoque"
                                    (change)="atualizar()"
                                />Estoque e local</label
                            >
                            <label
                                ><input
                                    type="checkbox"
                                    [(ngModel)]="options.ordemPo"
                                    (change)="atualizar()"
                                />Nº Ordem e Nº PO</label
                            >
                            <label
                                ><input
                                    type="checkbox"
                                    [(ngModel)]="options.cotacao"
                                    (change)="atualizar()"
                                />Cotação dólar</label
                            >
                            <label
                                ><input
                                    type="checkbox"
                                    [(ngModel)]="options.observacaoItem"
                                    (change)="atualizar()"
                                />Descrição dos itens (Obs.)</label
                            >
                        </fieldset>
                        <fieldset *ngIf="lista">
                            <legend>Colunas dos itens</legend>
                            <label *ngFor="let c of catalogoItens"
                                ><input
                                    type="checkbox"
                                    [(ngModel)]="colunasSelecionadas[c.chave]"
                                    (change)="atualizar()"
                                />{{ c.titulo }}</label
                            >
                        </fieldset>
                        <fieldset *ngIf="lista || pedido">
                            <legend>Campos do cabeçalho</legend>
                            <label *ngFor="let c of catalogoCabecalho"
                                ><input
                                    type="checkbox"
                                    [(ngModel)]="camposSelecionados[c.chave]"
                                    (change)="atualizar()"
                                />{{ c.titulo }}</label
                            >
                        </fieldset>
                        <fieldset>
                            <legend>Página</legend>
                            <label
                                >Ordenar por
                                <select
                                    aria-label="Ordenar por"
                                    [(ngModel)]="ordem"
                                    (change)="atualizar()"
                                >
                                    <option value="pn">PN</option>
                                    <option value="codprod">Código</option>
                                    <option value="descricao">Descrição</option>
                                    <option value="fabricante">
                                        Fabricante
                                    </option>
                                    <option value="seq">Lançamento</option>
                                    <option value="local">Local</option>
                                </select>
                            </label>
                            <label
                                >Orientação
                                <select
                                    aria-label="Orientação"
                                    [(ngModel)]="orientacao"
                                    (change)="atualizar()"
                                >
                                    <option value="portrait">Retrato</option>
                                    <option value="landscape">Paisagem</option>
                                </select>
                            </label>
                            <label
                                >Papel
                                <select
                                    aria-label="Papel"
                                    [(ngModel)]="papel"
                                    (change)="atualizar()"
                                >
                                    <option value="a4">A4</option>
                                    <option value="letter">Carta</option>
                                </select>
                            </label>
                        </fieldset>
                    </div>
                </details>
            </div>
        </header>

        <div class="print-sub-actions" *ngIf="documento">
            <div class="print-zoom-controls">
                <button
                    type="button"
                    class="print-zoom-button"
                    (click)="zoom = zoom < 1.6 ? zoom + 0.1 : 1.6"
                    title="Aumentar zoom"
                    aria-label="Aumentar zoom"
                >
                    +
                </button>
                <button
                    type="button"
                    class="print-zoom-button"
                    (click)="zoom = zoom > 0.5 ? zoom - 0.1 : 0.5"
                    title="Diminuir zoom"
                    aria-label="Diminuir zoom"
                >
                    −
                </button>
                <button
                    type="button"
                    class="print-zoom-button print-zoom-toggle"
                    (click)="zoom = zoom >= 1.6 ? 1 : 1.6"
                    [title]="
                        zoom >= 1.6
                            ? 'Voltar ao zoom padrão'
                            : 'Aplicar zoom máximo'
                    "
                >
                    <lucide-angular
                        [img]="zoom >= 1.6 ? ZoomOut : ZoomIn"
                        size="18"
                    ></lucide-angular>
                </button>
            </div>
            <div
                class="print-result-navigation"
                *ngIf="indiceDocumento >= 0 && resultadosFiltrados.length > 1"
            >
                <button
                    type="button"
                    class="print-navigation-button"
                    (click)="navegarDocumento(-1)"
                    [disabled]="indiceDocumento === 0 || carregando"
                >
                    Anterior
                </button>
                <span class="print-navigation-position"
                    >{{ indiceDocumento + 1 }} de
                    {{ resultadosFiltrados.length }}</span
                >
                <button
                    type="button"
                    class="print-navigation-button"
                    (click)="navegarDocumento(1)"
                    [disabled]="
                        indiceDocumento === resultadosFiltrados.length - 1 ||
                        carregando
                    "
                >
                    Próxima
                </button>
            </div>
            <button
                type="button"
                class="print-return-button"
                (click)="voltarOuFechar()"
            >
                {{ modoModal ? 'Fechar' : 'Voltar' }}
            </button>
        </div>
    </aside>

    <main class="print-content-shell">
        <div class="print-scroll-navigation no-print" *ngIf="modoModal">
            <button
                type="button"
                class="print-zoom-button"
                *ngIf="mostrarIrTopo"
                (click)="rolarImpressao(false)"
                title="Ir para o topo da impressão"
            >
                ↑
            </button>
            <button
                type="button"
                class="print-zoom-button"
                *ngIf="mostrarIrFinal"
                (click)="rolarImpressao(true)"
                title="Ir para o final da impressão"
            >
                ↓
            </button>
        </div>

        <section class="quick-sale-search no-print" *ngIf="!documento">
            <div class="quick-sale-title">
                Buscar {{ pedido ? 'pedido de compra' : 'pré-compra' }}
            </div>
            <form
                class="quick-sale-filters compra-nunota-search"
                (ngSubmit)="abrir()"
            >
                <label class="quick-sale-date">
                    <span>Nº único (NUNOTA)</span>
                    <input
                        name="nunota"
                        [(ngModel)]="nunota"
                        inputmode="numeric"
                        placeholder="Digite a NUNOTA"
                        autocomplete="off"
                    />
                </label>
                <button
                    type="submit"
                    class="quick-sale-search-button"
                    [disabled]="carregando || exportando"
                >
                    Abrir
                </button>
            </form>
            <div class="quick-sale-filters">
                <div class="quick-sale-field">
                    <input
                        type="text"
                        autocomplete="off"
                        placeholder="Digite o CNPJ ou nome do fornecedor…"
                        [(ngModel)]="termo"
                        (input)="agendarBuscaFornecedores()"
                        (keyup.enter)="buscarFiltroImpressao()"
                        (focus)="
                            termo.trim().length >= 2 &&
                                !fornecedorSelecionado &&
                                (dropdownFornecedoresAberto = true)
                        "
                        aria-label="Fornecedor"
                    />
                    <div
                        class="quick-sale-dropdown"
                        *ngIf="dropdownFornecedoresAberto"
                    >
                        <button
                            type="button"
                            class="quick-sale-option"
                            *ngFor="let fornecedor of fornecedoresBusca"
                            (click)="selecionarFornecedor(fornecedor)"
                        >
                            {{ labelFornecedor(fornecedor) }}
                        </button>
                        <div
                            class="quick-sale-empty"
                            *ngIf="
                                !fornecedoresBusca.length && mensagemFornecedor
                            "
                        >
                            {{ mensagemFornecedor }}
                        </div>
                    </div>
                </div>
                <label class="quick-sale-date"
                    ><span>Dt. inicial</span
                    ><input type="date" [(ngModel)]="de"
                /></label>
                <label class="quick-sale-date"
                    ><span>Dt. final</span><input type="date" [(ngModel)]="ate"
                /></label>
                <button
                    type="button"
                    class="quick-sale-search-button"
                    (click)="buscarFiltroImpressao()"
                    [disabled]="buscando"
                >
                    {{ buscando ? 'Buscando…' : 'Buscar' }}
                </button>
            </div>
            <div class="quick-sale-selected" *ngIf="fornecedorSelecionado">
                <strong>{{ labelFornecedor(fornecedorSelecionado) }}</strong>
                <span>Compras do fornecedor no período selecionado</span>
            </div>
            <div
                class="quick-sale-notes compra-resultados"
                *ngIf="resultadosFiltrados.length"
            >
                <div
                    class="quick-sale-note quick-sale-note-header"
                    aria-hidden="true"
                >
                    <span>Nº ÚNICO</span><span>FORNECEDOR</span><span>DATA</span
                    ><span>STATUS</span><span>VALOR R$</span>
                </div>
                <button
                    type="button"
                    class="quick-sale-note"
                    *ngFor="let r of resultadosFiltrados"
                    (click)="abrir(r.nunota)"
                >
                    <span class="note-mono note-nunota">{{ r.nunota }}</span>
                    <span>{{ r.fornecedor }}</span
                    ><span class="note-date">{{ r.dtmov }}</span
                    ><span class="note-status">{{
                        r.gplStatus || r.status
                    }}</span
                    ><span class="note-value">{{ valor(r.vlrnota) }}</span>
                </button>
            </div>
            <div
                class="quick-sale-empty quick-sale-message"
                role="status"
                *ngIf="!resultadosFiltrados.length"
            >
                {{
                    mensagemBusca ||
                        'Informe a NUNOTA ou o fornecedor e o período para localizar a compra.'
                }}
            </div>
        </section>

        <div class="loading-overlay" *ngIf="carregando">
            <app-loading-indicator></app-loading-indicator>
        </div>
        <div
            class="quick-sale-empty compra-message no-print"
            role="alert"
            *ngIf="erro"
        >
            {{ erro }}
        </div>
        <div
            class="quick-sale-empty compra-message no-print"
            *ngIf="documento && semCotacao && (dolar || options.dolar)"
        >
            Este documento não tem cotação válida. Valores convertidos aparecem
            como “—”.
        </div>
        <div
            class="quick-sale-empty compra-message no-print"
            *ngIf="documento && !folhas.length"
        >
            Nenhum item corresponde às opções selecionadas.
        </div>

        <div class="print-pages">
            <article
                class="paper page"
                *ngFor="let folha of folhas; let pagina = index"
                [class.pb]="pb"
                [class.impressao-pb-page]="pb"
                [style.--page-width]="larguraMm + 'mm'"
                [style.--compra-page-height]="alturaMm + 'mm'"
                [style.width.mm]="larguraMm"
                [style.min-height.mm]="alturaMm"
                [style.zoom]="zoom"
            >
                <div class="report-header">
                    <header class="header-grid">
                        <div class="brand">
                            <img
                                class="logo"
                                src="/assets/logo_global.png"
                                alt="Logo Global Parts"
                            />
                            <div class="company-line">
                                <div>
                                    <strong>CNPJ:</strong>
                                    <span>{{
                                        formatar(documento.CNPJEMP)
                                    }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="system-box">
                            <span>{{
                                internacional ? 'Company' : 'Empresa'
                            }}</span
                            ><strong>{{ documento.CODEMP }}</strong>
                            <span>{{ internacional ? 'User' : 'Usuário' }}</span
                            ><strong>{{ auth.getUserName() }}</strong>
                            <span>{{
                                internacional ? 'Date / Time' : 'Data / Hora'
                            }}</span
                            ><strong>{{ dataImpressao }}</strong>
                        </div>
                    </header>

                    <section class="doc-title">
                        <div class="quote-number">
                            <span>{{
                                internacional ? 'Order' : 'Nº único'
                            }}</span
                            ><strong>{{ documento.NUNOTA }}</strong>
                        </div>
                        <div class="quote-heading">
                            <h1>{{ tituloDocumento }}</h1>
                        </div>
                        <div class="quote-id">
                            <svg
                                *ngIf="options.barras"
                                [attr.viewBox]="'0 0 ' + larguraBarras + ' 32'"
                                role="img"
                                [attr.aria-label]="
                                    'Código de barras da NUNOTA ' +
                                    documento.NUNOTA
                                "
                            >
                                <rect
                                    *ngFor="let b of barras"
                                    [attr.x]="b.x"
                                    y="0"
                                    [attr.width]="b.largura"
                                    height="32"
                                    fill="currentColor"
                                ></rect>
                            </svg>
                        </div>
                    </section>

                    <div class="top-fields compra-meta">
                        <div class="meta-panel" *ngFor="let lado of [0, 1]">
                            <ng-container
                                *ngFor="
                                    let campo of camposDocumento;
                                    let i = index
                                "
                            >
                                <div class="field-row" *ngIf="i % 2 === lado">
                                    <span>{{ campo.titulo }}</span
                                    ><strong>{{ campo.valor }}</strong>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <div class="compra-parties" *ngIf="!lista && !pedido">
                        <section class="section-block">
                            <div class="section-title">
                                {{
                                    internacional
                                        ? 'Vendor Information'
                                        : 'Fornecedor'
                                }}
                            </div>
                            <div class="compra-party-fields">
                                <strong>{{
                                    formatar(cabecalho.cliente)
                                }}</strong>
                                <p *ngIf="options.faturamento">
                                    {{ formatar(documento.ENDFATURA) }}<br />{{
                                        formatar(documento.CNPJ)
                                    }}
                                    · {{ formatar(documento.TELPARC) }}
                                </p>
                            </div>
                        </section>
                        <section class="section-block" *ngIf="options.entrega">
                            <div class="section-title">
                                {{ internacional ? 'Ship To' : 'Entrega' }}
                            </div>
                            <div class="compra-party-fields">
                                <strong>{{
                                    formatar(documento.PARCEIROENTREGA)
                                }}</strong>
                                <p>
                                    {{ formatar(documento.ENDENTREGA) }}<br />{{
                                        formatar(documento.CNPJENTREGA)
                                    }}
                                    · {{ formatar(documento.TELENTREGA) }}
                                </p>
                            </div>
                        </section>
                    </div>
                    <div
                        class="section-title section-title-framed manufacturer-group"
                        *ngIf="folha.fabricante"
                    >
                        Fabricante: {{ folha.fabricante }}
                    </div>

                    <section
                        class="observation-section pedido-observation-section"
                        *ngIf="
                            pedido &&
                            pagina === 0 &&
                            camposSelecionados['observacao']
                        "
                    >
                        <div class="section-title section-title-framed">
                            {{ internacional ? 'Comments or Special Instructions' : 'Observações' }}
                        </div>
                        <div class="observation-content">
                            {{ formatar(cabecalho.observacao) }}
                        </div>
                    </section>
                </div>

                <table class="items-table">
                    <colgroup>
                        <col
                            *ngFor="let c of colunas"
                            [style.width.%]="larguraColuna(c)"
                        />
                    </colgroup>
                    <thead>
                        <tr class="items-title-row">
                            <th
                                class="items-title-cell"
                                [attr.colspan]="colunas.length"
                            >
                                {{
                                    internacional
                                        ? 'Parts / Products'
                                        : 'Lista de Peças / Produtos'
                                }}
                            </th>
                        </tr>
                        <tr>
                            <th
                                *ngFor="let c of colunas"
                                [class.num]="c.formato"
                                [class.compra-col-ord]="c.chave === 'seq'"
                                [class.compra-col-descricao]="c.chave === 'descricao'"
                                [class.compra-col-pn]="c.chave === 'pn'"
                                [class.compra-col-unidade]="c.chave === 'unidade'"
                                [class.compra-col-fabricante]="c.chave === 'fabricante'"
                            >
                                {{
                                    internacional
                                        ? c.ingles || c.titulo
                                        : c.titulo
                                }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            class="item-row"
                            *ngFor="let item of folha.itens; let i = index"
                            [class.item-row-alt]="i % 2 !== 0"
                        >
                            <td
                                *ngFor="let c of colunas"
                                [class.num]="c.formato"
                                [class.compra-col-ord]="c.chave === 'seq'"
                                [class.compra-col-descricao]="c.chave === 'descricao'"
                                [class.compra-col-pn]="c.chave === 'pn'"
                                [class.compra-col-unidade]="c.chave === 'unidade'"
                                [class.compra-col-fabricante]="c.chave === 'fabricante'"
                                style="border-top: 1px solid #eef1f5"
                            >
                                {{ formatar(item[c.chave], c) }}
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div
                    class="report-bottom print-bottom-block"
                    *ngIf="folha.ultima"
                >
                    <section
                        class="observation-section"
                        *ngIf="
                            !pedido &&
                            ((!lista && !pedido) ||
                            camposSelecionados['observacao'])
                        "
                    >
                        <div class="section-title section-title-framed">
                            {{
                                internacional
                                    ? 'Comments or Special Instructions'
                                    : 'Observações'
                            }}
                        </div>
                        <div class="observation-content">
                            {{ formatar(cabecalho.observacao) }}
                        </div>
                    </section>
                    <section
                        class="totals"
                        *ngIf="!pedido && !lista && options.valores"
                    >
                        <div class="core-note">
                            <strong>CORE</strong
                            ><span
                                >{{
                                    internacional
                                        ? 'Included in saved item prices'
                                        : 'Incluído nos preços dos itens'
                                }}: {{ moeda }} {{ valor(coreTotal) }}</span
                            >
                        </div>
                        <div class="total-box">
                            <div
                                *ngFor="let total of totais; let ultima = last"
                                [class.total-row]="!ultima"
                                [class.invoice-total]="ultima"
                            >
                                <div class="total-label">
                                    {{ total.titulo }} {{ moeda }}
                                </div>
                                <div class="num">{{ valor(total.valor) }}</div>
                            </div>
                        </div>
                    </section>
                </div>
                <footer class="report-footer footer">
                    <div class="footer-code">{{ documento.CODEMP }}</div>
                    <div>
                        {{ documento.RAZAOSOCIAL }} · {{ documento.CNPJEMP }}
                    </div>
                    <div class="footer-page">
                        {{ internacional ? 'Page' : 'Página' }}
                        {{ pagina + 1 }} / {{ folhas.length }}
                    </div>
                </footer>
            </article>
        </div>
    </main>
</div>
